<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredFileList"
      :single-select="singleSelect"
      show-select
      :must-sort="true"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :server-items-length="totalBoardFileCount"
      @page-count="pageCount = $event"
      hide-default-footer
      class="tb-contents bds_033">

      <template v-slot:[`item.fileName`]="{ item }">
        <div class="subject ell-singleline large" 
          :class="
            item.fileExtDesc === 'ppt' ? 'ico-file-ppt' :
            item.fileExtDesc === 'word' ? 'ico-file-word' :
            item.fileExtDesc === 'excel' ? 'ico-file-xlsx' :
            item.fileExtDesc === 'pdf' ? 'ico-file-pdf' :
            item.fileExtDesc === 'jpg' ? 'ico-file-jpg' :
            item.fileExtDesc === 'gif' ? 'ico-file-gif' :
            item.fileExtDesc === 'png' ? 'ico-file-png' :
            item.fileExt === 'tif' ? 'ico-file-tif' :
            item.fileExt === 'tiff' ? 'ico-file-tiff' :
            item.fileExt === 'bmp' ? 'ico-file-bmp' :
            item.fileExt === 'zip' ? 'ico-file-zip' :
            item.fileExt === 'hwp' ? 'ico-file-hwp' :
            'ico-file-etc'
          "
        >
          <span class="ell-singleline ty1" @click="openFileViewer(item)">{{ item.fileName }}</span>
          <div class="file-lock board-filelist " :style="fileLockYn && selectedFileId == item.id? '':'display:none;'"></div>
        </div>
      </template>

      <template v-slot:[`item.lastModDate`]="{ item }">
        <div v-if="isToday(item.lastModDate)">
          <momentAgo prefix="" suffix="전" :date="item.lastModDate" lang="kr"></momentAgo>
        </div>
        <div v-if="!isToday(item.lastModDate)">
          {{ $moment(item.lastModDate).format('YYYY.MM.DD') }}
        </div>
      </template>

      <template v-slot:[`item.lastModUserName`]="{ item }">
        <div class="droplayer tooltipmember relative right">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on"><b>{{ item.lastModUserName }}</b></v-btn>
            </template>
            <div class="dropdown-list">
              <UserTooltip
                :userId="item.lastModUserId"
              />
            </div>
          </v-menu>
        </div>
      </template>

      <template v-slot:[`item.more`]="{ item }">
        <div class="droplayer icon more right nosel">
          <v-menu bottom left @input="onMenuToggle">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" @click="checkStatus(attrs, item)">더보기</v-btn>
            </template>
            <div class="dropdown-list">
              <div class="dropdown-list-item"><div class="tit"><button type="button" @click="downloadSelectedFile(item)">{{ $i18nUtil.trans("button.file.download","다운로드") }}</button></div></div>
              <div class="dropdown-list-item"><div class="tit"><button type="button" :disabled="fileBtnDisabledYn" @click="deleteFileModal(item)">{{ $i18nUtil.trans("button.file.delete","파일 삭제") }}</button></div></div>
            </div>
          </v-menu>
        </div>
      </template>
      
      <template slot="no-data">
        <div class="nodata-txt file">
          <v-alert :value="true" v-if="!show">
            {{ $i18nUtil.trans("search.026","등록된 첨부파일이 없습니다.") }}
          </v-alert>
          <v-alert :value="true" v-if="show">
            {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
          </v-alert>
        </div>
      </template>
    </v-data-table>

    <div class="pagination">
      <v-pagination
        v-model="page"
        circle
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
export default {
  components: {
    UserTooltip
  },
  props: {
    filteredFileList: {
      type: Array
    },
    show: {
      type: Boolean
    },
    totalBoardFileCount: {
      type: Number
    }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.file.filter.division","구분"), align: 'center', sortable: false, value: 'locationKbnDesc', },
        { text: this.$i18nUtil.trans("entity.file.filter.fileName","파일명"), value: 'fileName', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdate","마지막 업데이트"), value: 'lastModDate', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdUserName","생성/수정자"), value: 'lastModUserName', sortable: true }, // 2021.02.09 정렬순서 화살표 숨김 처리 해제
        { text: this.$i18nUtil.trans("entity.file.filter.more","더보기"), value: 'more', sortable: false },
      ],
      /* 페이징 관련 */
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      /* 정렬 관련 */
      sortBy: 'lastModDate',
      sortDesc: true,
      changeTableData: false,

      fileBtnDisabledYn : true,
      fileLockYn: false,
      selectedFileId:''
    }
  },
  watch : {
    page: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
        window.scrollTo(0, 0);
      }
    },
    sortBy: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    sortDesc: {
      handler() {
        let obj = this;
        if(obj.changeTableData != true) {
          obj.changeTableData = true;
        }
      }
    },
    changeTableData: {
      handler() {
        let obj = this;
        if(obj.changeTableData == true) {
          setTimeout(() => {
            obj.changeTableData = false;
            obj.selected = [];
            obj.$emit("getBoardFileList", false);
          }, 500);
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 오늘 날짜 체크 */
    isToday(date) {
      let obj = this;
      let now = obj.$moment();
      let before24hours = obj.$moment().subtract(1, 'days');
      let lastUpdatedTime = obj.$moment(date);
      
      if(lastUpdatedTime.isBetween(before24hours, now)) {
        // 24시간 이내
        return true;
      } else {
        // 24시간 이후
        return false;
      }
    },
    /* 선택한 파일 다운로드 */
    downloadSelectedFile(item) {
      this.$emit("downloadSelectedFile", item);
    },
    /* 파일 삭제 모달 */
    deleteFileModal(item) {
      this.$emit("confirmDeleteFile", item);
    },
    /* 파일 뷰어 */
    openFileViewer(file) {
      let hanwha = $(location).attr("origin");
      let groupId = file.groupId;
      if (groupId != null || groupId != "") {
        window.open(
          hanwha + "/general/viewer/" + groupId + "/" + file.id
        );
      }
    },
    checkStatus(attrs, item){
      this.selectedFileId = item.id;
      if(attrs["aria-expanded"] == "false"){
        let obj = this;
        obj.fileBtnDisabledYn = true;
        obj.fileLockYn = false;
        let reqData = {
          url: "/api/cofile/paper/checkFileLock",
          method: "post",
          params : {
            fileId: item.id
            // paperBlockId: this.bdata.paperBlockId
          }
        };
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          if(res.errorCode != null) {
          } else { 
            if(res.result.LockType){
              if(res.result.LockType != "" && res.result.LockType === "NONE"){
                obj.fileBtnDisabledYn = false;
                obj.fileLockYn = false;
              }else{
                obj.fileBtnDisabledYn = true;
                obj.fileLockYn = true;
              }
            }else{
              obj.fileBtnDisabledYn = false;
              obj.fileLockYn = false;
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      }
    },
    onMenuToggle(opened){
      if(!opened){
        this.fileLockYn = false;
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/files/FileTable.vue